<template>
  <button
    :type="type"
    @click="back"
    :class="{
      'dirty-button-small': small,
      'text-align-center': centerText,
      'stretch-width': stretch,
    }"
  >
    <v-icon class="icon left" v-if="callout === 'left'" color="#009677" small>{{
      icons.mdiArrowLeft
    }}</v-icon>
    {{ title }}
    <v-icon
      class="icon right"
      v-if="callout === 'right'"
      color="#009677"
      small
      >{{ icons.mdiArrowRight }}</v-icon
    >
  </button>
</template>

<script>
import { mdiArrowLeft, mdiArrowRight } from "@mdi/js";
export default {
  name: "DirtyButton",
  components: {
    mdiArrowLeft,
    mdiArrowRight,
  },
  data() {
    return {
      icons: {
        mdiArrowLeft: mdiArrowLeft,
        mdiArrowRight: mdiArrowRight,
      },
    };
  },
  props: {
    type: {
      required: false,
      default: "button",
      type: String,
    },
    title: {
      required: false,
      default: "BACK",
      type: String,
    },
    small: {
      required: false,
      default: false,
      type: Boolean,
    },
    hasIcon: {
      required: false,
      default: true,
      type: Boolean,
    },
    callout: {
      required: false,
      default: undefined,
      type: String,
    },
    centerText: {
      required: false,
      default: false,
      type: Boolean,
    },
    stretch: {
      required: false,
      default: false,
      type: Boolean,
    },
    loading: {
      required: false,
      default: false,
      type: Boolean
    }
  },
  methods: {
    back() {
      this.$emit("dirtyButtonClicked");
    },
  },
};
</script>

<style scoped lang="scss">
button {
  height: 56px;
  padding: 18px 32px 18px 32px;
  border-radius: 30px;
  font-size: 16px;
  font-weight: 500;
  line-height: 20.8px;
  text-align: center;
  text-wrap: nowrap;
  display: flex;
  align-items: center;
  color: #009677;
  border: 1px solid #009677;
  background-color: #eef8ed;

  .icon.left {
    margin-right: 8px;
  }
  .icon.right {
    margin-left: 8px;
  }
  &:hover {
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.16),
      0px 4px 12px 0px rgba(40, 40, 40, 0.18);
  }
}

.dirty-button-small {
  padding: 12px 20px 12px 20px;
  height: 44px;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: 0.005em;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: 0.005em;
  text-wrap: nowrap;
  display: flex;
  align-items: center;
}
.text-align-center {
  justify-content: center;
}
.stretch-width {
  width: 100%;
}
</style>
